export default function menu() {
  $('section.nav-bar div.container button').click(function() {
    var element = $(this)
    if (element.hasClass('active')) {
      $('section.nav-bar div.container div.links > button').removeClass('active')
      $('section.nav-bar div.container div.products').fadeOut(400)
      setTimeout(() => {
        $('section.nav-bar div.container div > a').removeClass('hide')
        $('section.nav-bar div.container div > a').addClass('show')
        $('section.nav-bar div.container').removeClass('resize')
      }, 500)
    } else {
      $('section.nav-bar div.container div > a').removeClass('show')
      $('section.nav-bar div.container div > a').addClass('hide')
      $('section.nav-bar div.container div.links > button').addClass('active')
      $('section.nav-bar div.container').addClass('resize')
      setTimeout(() => {
        $('section.nav-bar div.container div.products').css({
          display: 'flex',
          opacity: '0',
        })
        $('section.nav-bar div.container div.products').animate(
          {
            opacity: '1',
          },
          50
        )
      }, 300)
    }
  })

  $('section.nav-bar div.container svg.close').click(function() {
    $('section.nav-bar div.container div.links > button').removeClass('active')
    $('section.nav-bar div.container div.products').fadeOut(400)
    setTimeout(() => {
      $('section.nav-bar div.container div > a').removeClass('hide')
      $('section.nav-bar div.container div > a').addClass('show')
      $('section.nav-bar div.container').removeClass('resize')
    }, 500)
  })

  $('section.nav-bar div.container div.products div.text ul li').hover(
    function() {
      var newSrc = $(this).attr('data-url')
      $('section.nav-bar div.container div.products div.illustration img').attr('src', newSrc)
    },
    function() {}
  )

  //mobile
  $('section.nav-bar-mobile div.container button.button-menu-products').click(function() {
    $('section.nav-bar-mobile div.menu-products').fadeToggle()
  })

  $('section.nav-bar-mobile div.menu-products svg.close').click(function() {
    $('section.nav-bar-mobile div.menu-products').fadeToggle()
  })

  $('section.nav-bar-mobile div.container button.button-menu').click(function() {
    $('section.nav-bar-mobile div.menu').fadeToggle()
  })

  $('section.nav-bar-mobile div.menu svg.close').click(function() {
    $('section.nav-bar-mobile div.menu').fadeToggle()
  })

  $(document).ready(function() {
    var lastScrollTop = 0
    $(window).scroll(function() {
      var currentScroll = $(this).scrollTop()
      if (currentScroll > lastScrollTop) {
        $('#header > div.container').css('transform', 'translateY(-90px)')
      } else {
        $('#header > div.container').css('transform', 'translateY(0px)')
      }
      lastScrollTop = currentScroll
    })
  })
}
